import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import type { TenantLocaleConfig } from '~/constants/config/tenant';

const DEFAULT_NAMESPACES = [
  'common',
  'auth',
  'catalog-operations',
  'configuration',
  'connector',
  'content-enrichment',
  // Preloaded: the Coverage Report renders its title, tabs and headers from it on first paint.
  'coverage',
  'dashboard',
  'experiments',
  'explorer',
  'exports',
  'integrations',
  'item-setup',
  'onboarding',
  'platform',
  'product-catalog',
  'settings',
  'subsidiary-configuration',
  'taxonomy-studio',
  'transformers',
] as const;

const DEFAULT_SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es'] as const;

// Side-effect: starts i18n initialization when this module is imported.
// useSuspense:false — components render keys and update when translations arrive.
void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [...DEFAULT_SUPPORTED_LANGUAGES],
    ns: [...DEFAULT_NAMESPACES],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
    react: { useSuspense: false },
  });

/**
 * Update i18n language for a tenant-specific locale.
 * Call after auth hydration when tenant config is available.
 */
export async function configureForTenant(tenantLocale: TenantLocaleConfig): Promise<void> {
  await i18n.changeLanguage(tenantLocale.defaultLanguage);
}

export default i18n;
